// extracted by mini-css-extract-plugin
export default {"sectionWrap":"AdditionalSection_sectionWrap__Pu4Lq","header":"AdditionalSection_header__E-1+v","title":"AdditionalSection_title__CiV61"};